import type { OptionsMap } from '@openx/types/options.ts';
import type { RetargetingFormState } from '@openx/types/targeting/retargeting.ts';
import { noop } from '@openx/utils/noop.ts';
import type { TargetingItemsProps } from '../types.ts';
import { SegmentListDisplay } from './components/SegmentListDisplay.tsx';

type RetargetingItemsProps = TargetingItemsProps<RetargetingFormState> & {
  onClear: () => void;
  isLoading?: boolean;
  options?: OptionsMap;
};

export const Items = ({
  targetingParams,
  readonly = true,
  onClear = noop,
  isLoading = false,
  options,
}: RetargetingItemsProps) => {
  return (
    <SegmentListDisplay
      segment={targetingParams}
      readonly={readonly}
      onClear={onClear}
      isLoading={isLoading}
      options={options}
    />
  );
};
